import { v4 as uuid } from "uuid";
import { boolean, date, object, string, ObjectSchema } from "yup";

import type { Stable } from "@/types";
import { addressSchema } from "./clientSchema.ts";

export const stableSchema: ObjectSchema<Stable> = object({
  _id: string()
    .uuid()
    .required()
    .default(() => uuid()),
  _rev: string().optional(),
  _deleted: boolean().optional(),
  type: string().ensure().required().oneOf(["stable"]).default("stable"),
  createdAt: date().optional(),
  updatedAt: date().optional(),
  name: string().label("Name").ensure().required().min(2),
  phone: string().label("Phone").ensure(),
  email: string().label("E-Mail").ensure().email(),
  address: addressSchema.default(() => addressSchema.getDefault()),
  notes: string().label("Notes").ensure(),
  active: boolean().default(true),
  clientId: string().label("Client").uuid().optional(),
});
